import { GET_ROUTINE, GET_EXERCISE, GET_GENERAL_ROUTINE } from "./actions";

const initialState = {
  Routine: [],
  Exercise: [],
  General: []
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ROUTINE:
      return { ...state, Routine: action.payload };
    case GET_EXERCISE:
      return { ...state, Exercise: action.payload };
    case GET_GENERAL_ROUTINE:
      return { ...state, General: action.payload };
    default:
      return state;
  }
};


export default rootReducer;
